module.exports = __webpack_public_path__ + "img/bus.2e7ce9e8.png";